import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { getBattles } from "@/lib/api";
import { trackCompetition } from "@/lib/competitionAnalytics";

function groupBattles(battles) {
  const active = [];
  const upcoming = [];
  const completed = [];
  for (const b of battles || []) {
    if (b.status === "active") active.push(b);
    else if (b.status === "scheduled") upcoming.push(b);
    else if (b.status === "completed") completed.push(b);
  }
  return { active, upcoming, completed };
}

function BattleRow({ battle }) {
  return (
    <Link
      to={`/battle/${battle.slug}`}
      className="block rounded-xl border border-white/10 bg-white/[0.02] px-4 py-4 transition-colors hover:border-white/25"
      data-testid={`battle-row-${battle.slug}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="font-display text-lg font-black tracking-tight">{battle.title}</div>
          <div className="mt-1 text-[11px] uppercase tracking-wider text-zinc-500">
            {battle.status} · {battle.entity_category}
            {battle.metadata?.demo ? " · Demo" : ""}
          </div>
        </div>
        <div className="text-xs text-zinc-500">
          {new Date(battle.starts_at).toUTCString()} → {new Date(battle.ends_at).toUTCString()}
        </div>
      </div>
    </Link>
  );
}

export default function BattlesPage() {
  const [battles, setBattles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    trackCompetition("BATTLE_LIST_VIEW");
    getBattles()
      .then((data) => setBattles(data.battles || []))
      .catch(() => setBattles([]))
      .finally(() => setLoading(false));
  }, []);

  const groups = groupBattles(battles);

  return (
    <div className="min-h-screen grain">
      <Navbar category="tokens" />
      <main className="mx-auto max-w-4xl px-4 py-8">
        <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-600">Competition</p>
        <h1 className="mt-2 font-display text-4xl font-black tracking-tight">Battles</h1>
        <p className="mt-3 max-w-2xl text-sm text-zinc-400">
          Head-to-head Verified Backing rivalries. No rewards. No sponsor pools. Rank is earned only by confirmed Backing.
        </p>
        {loading && <div className="mt-8 text-sm text-zinc-500">Loading…</div>}
        {!loading && (
          <div className="mt-8 space-y-8">
            {[
              ["Active", groups.active],
              ["Upcoming", groups.upcoming],
              ["Recently completed", groups.completed],
            ].map(([label, rows]) => (
              <section key={label}>
                <h2 className="mb-3 text-[10px] uppercase tracking-[0.2em] text-zinc-600">{label}</h2>
                <div className="space-y-2">
                  {rows.map((b) => <BattleRow key={b.id} battle={b} />)}
                  {!rows.length && (
                    <div className="rounded-xl border border-white/10 px-4 py-6 text-sm text-zinc-500">
                      None right now.
                    </div>
                  )}
                </div>
              </section>
            ))}
          </div>
        )}
        <p className="mt-10 text-[11px] text-zinc-600">
          Gap math uses the same $1 minimum outbid as the main board.
        </p>
      </main>
    </div>
  );
}
